import React, { useState } from 'react';
import {
    BiChevronDown,
    BiHome,
    BiLineChart,
    BiMenu,
    BiRadioCircleMarked
} from "react-icons/bi";
import { ImSwitch } from 'react-icons/im';
import { FaBarsStaggered } from 'react-icons/fa6';
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../Redux/authSlice';
import "./sidebar.css";

const Sidebar = () => {
    const [onHover, setOnHover] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = useSelector((state) => state.auth.role);

    const handleShow = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };

    return (
        <div className={`wrapper ${toggle ? "toggled" : ""} ${onHover ? "sidebar-hovered" : ""}`}>
            {/* Sidebar wrapper */}
            <div className="sidebar-wrapper" data-simplebar="true">
                <div className="sidebar-header">
                    <div>
                        <h4 className="logo-text">AR E-Cart</h4>
                    </div>
                </div>

                {/* Navigation */}
                <ul className="metismenu mm-show" id="menu">

                    {/* Dashboard - Only admin */}
                    {role === "admin" && (
                        <li>
                            <Link to="/portal/dashboard" className="text-decoration-none">
                                <div className="parent-icon d-flex">
                                    <BiHome />
                                </div>
                                <div className="menu-title">Dashboard</div>
                            </Link>
                        </li>
                    )}

                    {/* Orders - All users */}
                    <li className={openMenu === "orders" ? "active-dropdown" : "mm-active"}>
                        <a
                            className=" text-decoration-none d-flex align-items-center justify-content-between"
                            role="button"
                            onClick={() => handleShow("orders")}
                        >
                            <div className="d-flex align-items-center">
                                <div className="parent-icon">
                                    <BiLineChart />
                                </div>
                                <div className="menu-title ms-2">Orders</div>
                            </div>
                            <BiChevronDown
                                size={20}
                                className={openMenu === "orders" ? "arrow rotate" : "arrow"}
                            />
                        </a>

                        <ul className={`mm-collapse ${openMenu === "orders" ? "mm-show" : ""}`}>
                            <li>
                                <Link to="/portal/update-orders" className='text-decoration-none'>
                                    <BiRadioCircleMarked size={18} className='me-1' />
                                    Update Orders
                                </Link>
                            </li>
                            <li>
                                <Link to="/portal/add-orders" className='text-decoration-none'>
                                    <BiRadioCircleMarked size={18} className='me-1' />
                                    Add Orders
                                </Link>
                            </li>
                            <li>
                                <Link to="/portal/confirm-orders" className='text-decoration-none'>
                                    <BiRadioCircleMarked size={18} className='me-1' />
                                    Confirm Orders
                                </Link>
                            </li>
                            <li>
                                <Link to="/portal/print-orders" className='text-decoration-none'>
                                    <BiRadioCircleMarked size={18} className='me-1' />
                                    Print Orders
                                </Link>
                            </li>
                        </ul>
                    </li>

                    {/* Settings - Only admin */}
                    {role === "admin" && (
                        <li className={openMenu === "settings" ? "active-dropdown" : "mm-active"}>
                            <a
                                className=" text-decoration-none d-flex align-items-center justify-content-between"
                                role="button"
                                onClick={() => handleShow("settings")}
                            >
                                <div className="d-flex align-items-center">
                                    <div className="parent-icon">
                                        <BiLineChart />
                                    </div>
                                    <div className="menu-title ms-2">Settings</div>
                                </div>
                                <BiChevronDown
                                    size={20}
                                    className={openMenu === "settings" ? "arrow rotate" : "arrow"}
                                />
                            </a>

                            <ul className={`mm-collapse ${openMenu === "settings" ? "mm-show" : ""}`}>
                                <li>
                                    <Link to="/portal/user" className='text-decoration-none'>
                                        <BiRadioCircleMarked size={18} className='me-1' />
                                        Add User
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" className='text-decoration-none'>
                                        <BiRadioCircleMarked size={18} className='me-1' />
                                        Change Password
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    )}
                </ul>
                {/* End Navigation */}
            </div>

            {/* Header / Topbar */}
            <header>
                <div className="topbar d-flex align-items-center">
                    <div className='text-white'>
                        <FaBarsStaggered
                            onClick={() => setToggle(!toggle)}
                            size={22} color='white' className='cursor-pointer ms-4'
                        />
                    </div>

                    <nav className="navbar navbar-expand">
                        <div className="mobile-toggle-menu" onClick={() => setToggle(!toggle)}>
                            <BiMenu />
                        </div>
                        <div className="top-menu ms-auto">
                            <ul className="navbar-nav align-items-center">
                                <div onClick={handleLogout}>
                                    <ImSwitch size={22} color='white' />
                                </div>
                            </ul>
                        </div>
                    </nav>
                </div>
            </header>

            {/* Page Content */}
            <div className="page-wrapper">
                <div className="page-content">
                    <Outlet />
                </div>
            </div>

            <div className="overlay toggle-icon"></div>
        </div>
    );
};

export default Sidebar;
